import React from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { mergeDeep } from '../../../../helpers/utils';

import Box from '../../../elements/Box';

const modifiers = (fareItem, isLowest, dataType) => {
  const { lowestHistogramBar, noPriceAvailableHistogramBar, histogramBar } = fareItem;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { className, ...obj } = histogramBar;
  const modifiersObj = {};

  // noPriceAvailable
  if (dataType === 'EMPTY_FROM_API') {
    Object.assign(modifiersObj, noPriceAvailableHistogramBar);
  }
  // isLowest
  if (isLowest) {
    Object.assign(modifiersObj, lowestHistogramBar);
  }
  const target = mergeDeep({}, obj);
  const result = mergeDeep(target, modifiersObj);

  return result;
};

const MonthlyHistogramBarV2 = ({
  fareItem,
  data,
  tabIndex,
  tabIndexCallToAction,
  focusReferences,
  fareItem: { barHeightAutoWhenNoData, heightBar },
  ...props
}) => {
  const {
    fare,
    fare: { dataType, allFaresEmpty },
    isLowest,
    FareComponentInstance,
    fareItemHeight,
    fareItemMaxHeight
  } = data;
  const [className] = useStyles(props);
  const monthHistogramBar = modifiers(fareItem, isLowest, dataType);

  const barHeight =
    allFaresEmpty && barHeightAutoWhenNoData ? `${heightBar}px` : `${fareItemMaxHeight}px`;
  return (
    <Box className={`fr-monthly-carousel fr-monthly-histogram-bar-v2 ${className}`} width="100">
      <Box
        width="100"
        display="flex"
        flexDirection="column"
        className="fr-monthly-histogram-bar-v2"
        style={{
          paddingTop: `${fareItemMaxHeight - fareItemHeight}px !important`,
          height: barHeight,
          justifyContent: 'flex-end'
        }}
      >
        <Box
          marginTop="auto"
          margin="1"
          style={{ height: `${fareItemHeight}px` }}
          {...monthHistogramBar}
        />
        <FareComponentInstance
          {...fareItem}
          data={fare}
          isLowest={isLowest}
          showDay={false}
          tabIndex={tabIndex}
          focusReferences={focusReferences}
          tabIndexCallToAction={tabIndexCallToAction}
        />
      </Box>
    </Box>
  );
};

MonthlyHistogramBarV2.propTypes = {
  fareItem: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  tabIndex: PropTypes.bool,
  tabIndexCallToAction: PropTypes.bool,
  focusReferences: PropTypes.func
};

MonthlyHistogramBarV2.defaultProps = {
  fareItem: {},
  data: {},
  tabIndex: false,
  tabIndexCallToAction: true,
  focusReferences: () => {}
};

export default MonthlyHistogramBarV2;
